import { render } from "./HelpAhsCIR.vue?vue&type=template&id=7453178b&scoped=true"
import script from "./HelpAhsCIR.vue?vue&type=script&lang=js"
export * from "./HelpAhsCIR.vue?vue&type=script&lang=js"

import "./HelpAhsCIR.vue?vue&type=style&index=0&id=7453178b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7453178b"]])

export default __exports__